<tt-field-group v-bind="{ id, describedbyId, errorText, hintText, label, required }">
  <div class="tt-o-selectbox">
    <select :id="id" :name="name" :disabled="disabled" @change="updateValue"
            :aria-describedby="describedbyIdValue"
            :aria-required="required ? 'true' : 'false'"
            :aria-invalid="errorText ? 'true' : 'false'">
      <option v-if="selectOneText" value="" :selected="!modelValue" :hidden="required" :disabled="required" v-html="selectOneText"></option>
      <option v-for="option in options" :value="option.value" :selected="option.value == modelValue">{{ option.label }}</option>
    </select>
    <span class="tt-o-arrow--down"></span>
  </div>
</tt-field-group>